// @flow
import React from "react"
import Radio from "@kiwicom/orbit-components/lib/Radio"
import Stack from "@kiwicom/orbit-components/lib/Stack"
import styled from "styled-components"

const Wrapper = styled.span`
  > label > div:last-of-type {
    flex: 0 0 auto;
  }

  margin-bottom: 8px !important;
`

type Props = {
  modes: Array<any>, // invariant arrays
  handleChange: string => void,
  active: ?(number | string),
}

const RadioButtons = ({ modes, handleChange, active }: Props) => (
  <Stack
    direction="column"
    spacing="compact"
    tablet={{ direction: "row", spacing: "comfy" }}
    inline
    wrap
  >
    {modes.map(mode => (
      <Wrapper key={mode.value}>
        <Radio
          onChange={() => handleChange(mode.value)}
          checked={active === mode.value}
          value={mode.value}
          label={mode.label || mode.customLabel}
          disabled={mode.disabled}
        />
      </Wrapper>
    ))}
  </Stack>
)

export default RadioButtons
